import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppVersion } from '../modelinterfaces/app-version.model';
import { EnvironmentHelper } from './environment-helper';

@Injectable({
  providedIn: 'root'
})

export class AppVersionService {

  constructor(private http: HttpClient, private environmentHelper: EnvironmentHelper) {
  }

  public get(): Observable<AppVersion> {
    const url = `${this.environmentHelper.urlV2}/appVersion`;
    return this.http.get<AppVersion>(url).pipe(
      map(version => AppVersion.valueOf(version)),
      // Запрет фичи APP_VERSION отдаёт 403: диалог должен показать одну строку GUI, а не падать.
      catchError(() => of(null))
    );
  }
}
